import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import { APPLICATION_CONTEXTS } from '../../constants';
import ImageButton from '../common/imageButton';
import ImageButtonList from '../common/imageButtonList';
import ImageBackground from '../common/imageBackground';
import ImageHeader from '../common/imageHeader';
import ImageText from '../common/imageText';
import PatientBanner from '../common/patientBanner';
import NavigationBar from '../common/navigationBar';
import './styles.css';

class MedicationEducationOptions extends Component {
  arrows = {
    down: require('../common/images/Arrow_down.png'),
    left: require('../common/images/Arrow_left.png'),
    right: require('../common/images/Arrow_right.png'),
    up: require('../common/images/Arrow_up.png')
  };

  /**
   * Handles on key down events
   *
   * @protected
   *
   **/
  handleOnKeyUp = event => {
    if (event.key === '1' && this.props.context === APPLICATION_CONTEXTS.SERVICES) {
      this.props.history.push('/medication_education/search');
    }
  };

  componentWillMount() {
    document.addEventListener('keyup', this.handleOnKeyUp, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleOnKeyUp);
  }

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1340">
        <ImageBackground id="background" />
        <ImageHeader {...this.props.header} />
        <ImageText {...this.props.text} />
        <PatientBanner {...this.props.banner} />
        <ImageButtonList {...this.props.imageButtonsList} imageButtons={this.props.imageButtons} />
        <NavigationBar {...this.props.navigationBar} />
        <img className="arrow arrow-down" src={this.arrows.down} alt="" />
        <img className="arrow arrow-left" src={this.arrows.left} alt="" />
        <img className="arrow arrow-right" src={this.arrows.right} alt="" />
        <img className="arrow arrow-up" src={this.arrows.up} alt="" />
        <ImageButton className="search-button" {...this.props.searchButton} />
        <ImageButton className="watch-video-button" {...this.props.watchVideoButton} />
      </div>
    );
  }
}

export default connect(
  state => ({
    context: state.application.currentContext
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        ...applicationActions
      },
      dispatch
    )
  })
)(MedicationEducationOptions);
